import { Toaster as Sonner, ToasterProps } from "sonner";

import { useTheme } from "@/hooks/useTheme";

export const RmToaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      position="top-right"
      duration={3000}
      theme={theme as ToasterProps["theme"]}
      expand
      className="toaster group pointer-events-auto"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};
